import { useState } from 'react';
import { useAppStore } from '../store';
import LegalAcceptance from './LegalAcceptance';
import Btn from './Btn';

export default function LegalConsentGate() {
  const [acceptance, setAcceptance] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [revision, setRevision] = useState(0);
  const confirm = async () => {
    if (!acceptance || busy) return;
    setBusy(true);
    setError('');
    try {
      await useAppStore.getState().acceptLegalDocuments(acceptance);
    } catch (err) {
      setError(err.message);
      if (err.code === 'legal_documents_changed') {
        setAcceptance(null);
        setRevision((n) => n + 1);
      }
    } finally { setBusy(false); }
  };
  return <main style={{ maxWidth: 720, margin: '0 auto', padding: '48px 24px', minHeight: '100vh' }}>
    <h1>Подтвердите документы</h1>
    <p>Для продолжения работы с аккаунтом ознакомьтесь с документами и подтвердите согласие.
      Ваш аккаунт, команды и заявки сохраняются. Дата согласия будет записана только после подтверждения.</p>
    <LegalAcceptance key={revision} onChange={setAcceptance} />
    {error && <p role="alert" style={{ color: 'var(--danger)' }}>{error}</p>}
    <div className="col gap-3" style={{ marginTop: 24 }}>
      <Btn full onClick={confirm} disabled={!acceptance || busy}>{busy ? 'Сохраняем…' : 'Подтвердить и продолжить'}</Btn>
      <button type="button" disabled={busy} onClick={() => useAppStore.getState().logout()}>
        Выйти и читать сайт без входа
      </button>
    </div>
  </main>;
}
